export default {
    "Overview": "概覽",
    "Energy": "能源",
    "KPI": "關鍵績效指標",
    "Notification Breakdown": "通知明細",
    "Monthly Summary": "每月摘要",
    "Plots": "圖表",
    "Time Series Plots": "時間序列圖",
    "Equipment Plots": "設備圖",
    "Facet Plots": "結合圖",
    "Scatter Plots": "散點圖",
    "Fault Detection": "故障檢測",
    "Fault Detection (Machine Learning)": "故障檢測（機器學習）",
    "Fault Summary": "故障摘要",
    "Diagnostics": "診斷",
    "Cooling Load": "冷卻負荷",
    "CHW Supply Temperature": "冷卻水供應溫度",
    "CHW Return Temperature": "冷卻水回流溫度",
    "Chiller Performance": "冷水機效能",
    "Cooling Performance": "冷卻效能",
    "Working Hours": "運行時數",
    "Chiller Overview": "冷水機概覽",
    "Config": "配置",
    "Equipments": "設備",
    "Facilities": "建築物",
    "Anomaly Descriptions": "異常描述",
    "Points": "傳感器",
    "Parameter": "參數",
    "Settings": "設定",
    "Report": "報告",
    "Rules": "規則",
    "Export Data": "輸出數據",
    "Custom Views": "自訂視圖",
    "Dates": "日期",
    "Equipment Servicing Schedule": "設備維護時間表",
    "Menu items": "菜單項目",
    "Maintenance Record": "維護紀錄",
    "Terms of Service": "服務條款",
    "Logged in as": "已登入為",
    "Account Settings": "帳戶設定",
    "Logout": "登出",
    "Loading Points List": "正加載傳感器列表",
    "Save": "儲存",
    "Cancel": "取消",
    "User Name": "用戶名",
    "Email": "電郵地址",
    "Change password?": "更改密碼？",
    "Issue": "問題",
    "Equipment": "設備",
    "Equipment Type": "設備類型",
    "Floor": "層數",
    "Start Date": "開始日期",
    "End Date": "結束日期",
    "Actions": "操作",
    "Energy Consumption VS Baseline": "能源消耗 VS 基準線",
    "Not including all equipment in the building": "不包括建築物中的所有設備",
    "Hour": "小時",
    "Fault severity": "故障嚴重程度",
    "Fault breakdown": "故障細目",
    "Room Temperature": "室溫",
    "AHU Run Time (hr)": "空氣冷卻機組運行時間（小時）",
    "Chiller Run Time (hr)": "冷水機運行時間（小時）",
    "User": "用家",
    "test": "測試",
    "Chillers": "冷水機",
    "Pumps": "泵",
    "VAVs": "可變風量",
    "AHUs": "空氣處理機組",
    "Cooling Towers": "冷卻塔",
    "Baseline": "基準線",
    "Power (Chiller only) ": "能量（僅用於冷水機）",
    "Time": "時間",
    "Power Consumption": "能量消耗",
    "Energy Consumption Profile": "能源消耗概況",
    "Time (hourly)": "時間（小時）",
    "Energy Consumption Breakdown": "能源消耗細目",
    "Air conditioning - Air side": "空調 - 空氣側",
    "Power Heat Map": "能量熱圖",
    "Chiller": "冷水機",
    "Chiller COP": "冷水機效能系數",
    "AHU": "空氣處理機組",
    "Annualized BPI": "年度BPI（建築價格指數）",
    "Occupant Comfort Index": "停留者舒適度",
    "Maintenance Fault Index": "維護故障率",
    "Energy Saving": "節能",
    "Severity": "嚴重程度",
    "Topic": "主題",
    "Download": "下載",
    "Alerts": "警報",
    "Recommended Actions": "建議操作",
    "Acknowledged": "已確認",
    "Occured between": "發生介於",
    "and": "及",
    "Add Maintenance Record": "添加維護紀錄",
    "View Chart": "查看圖表",
    "View Chart in New Tab": "在新分頁查看圖表",
    "Add maintenance record": "添加維護紀錄",
    "View chart": "查看圖表",
    "View maintenanace records for this period": "查看此期間的維護紀錄",
    "Equipment Health Score": "設備健康指數",
    "Export as PDF": "輸出為PDF",
    "Create Maintenance Record": "創建維護紀錄",
    "Jump to Equipment Trend Plots": "跳轉至設備趨勢圖",
    "Supervised Detection": "監督性檢測",
    "Algorithm Detection": "演算法檢測",
    "Health": "健康度",
    "Sensor": "感應器",
    "Supervised Detection Scores (Higher indicates error)": "監督性檢測指數（較高代表錯誤）",
    "Anomaly Detection Scores (Higher indicates error)": "異常檢測指數（較高代表錯誤）",
    "Unack": "未確認",
    "Medium": "中",
    "High": "高",
    " Critical": " 嚴重",
    "30 days": "30天",
    "90 days": "90天",
    "1 year": "1年",
    "all": "全部",
    "Keyword filter": "關鍵字過濾",
    "Critical/High/Medium": "嚴重/高/中",
    "Low": "低",
    "Anomaly": "異常",
    "Relevant variables": "相關變數",
    "Fault Analysis": "故障分析",
    "Export all as PDF": "全部輸出為PDF",
    "Rule evaluation": "規則評估",
    "Change": "變化",
    "Analysis": "分析",
    "Energy Consumption Comparison Summary": "能源消耗比較摘要",
    "Outdoor Temperature": "室外溫度",
    "Fault Severity": "故障嚴重程度",
    "Chiller Running Hours": "冷水機運行時數",
    "Fault Breakdown": "故障細目",
    "Weather": "天氣",
    "Baseline Weather": "基準天氣",
    "Print": "列印",
    "Energy/Faults": "能源/故障",
    "Chiller Plant Performance": "冷卻設備效能",
    "Current": "現在",
    "YTD this year": "本年度年初至今",
    "YTD last year": "前年度年初至今",
    "FDD Costs": "故障檢測診斷成本",
    "Unacknowledged": "未確認",
    "Total": "總計",
    "Plant COP (chiller only)": "設備效能系數（僅用於冷水機）",
    "Time ": "時間 ",
    "COP": "效能系數",
    "Chiller COP vs Cooling Load": "冷水機效能系數 vs 冷卻負荷",
    "Energy Consumption": "能源消耗",
    "Plant COP (chiller only) vs Outdoor Temperature": "設備效能系數（僅用於冷水機）vs 室外溫度",
    "Header Main Supply Temperature vs Outdoor Temperature": "結合供應溫度 vs 室外溫度",
    "Outdoor Temp": "室外溫度",
    "Header Main Supply Temperature": "結合供應溫度",
    "Chilled Water Delta Temp": "冷卻水溫度變化",
    "Temperature Diff": "溫度差異",
    "Chiller Plant": "冷卻設備",
    "Runtime": "運行時間",
    "Fault": "故障",
    "No fault detected from": "沒有發現故障",
    "to": "至",
    "View anomalies for": "查看此異常",
    "View notifications for": "查看此通知",
    "View equipment summary for": "查看此設備摘要",
    "FDD Faults": "故障檢測和診斷",
    "Recommended actions": "建議操作",
    "Most Expensive Faults. Total Cost": "修復成本最高的故障。總成本",
    "Faults With Highest Duration Of Occurrence (hr)": "維持時間最長的故障（小時）",
    "Date From": "從日期",
    "Date To": "至日期",
    "Fixed": "已修復",
    "Assigned to": "分配給",
    "Assigned by": "由...分配",
    "Assigned date": "分配日期",
    "Assigned to me": "分配給自己",
    "Assigned by me": "由自己分配",
    "View Points when Chiller is On":"查看冷水機開啟時的傳感器",
    "Latest Cooling Load Forecast":"最新冷卻負荷預測",
    "Forecast":"預測",
    "Chiller Staging Profile":"冷機排序概況",
    "Export charts as PDF":"輸出圖表為 PDF",
    "PMV":"預計平均熱感覺指數（PMV）",
    "View this rule on other equipments in":"在其他設備上查看此規則",
    "View faults for":"為...查看故障",
    "Date Range":"日期範圍",
    "Today":"今日",
    "Yesterday":"昨日",
    "Last 30 Days":"過去30日",
    "Fault Comparison":"比較故障",
    "Rule":"規則",
    "No matching equipments":"沒有匹配的設備",
    "No Fault detected for this range and equipment":"未檢測到該範圍和設備的故障",
    "Equipment Name":"設備名稱",
    "Search":"搜索",
    "Refresh":"更新",
    "Active (hr)":"運作時間（小時）",
    "Cost":"成本",
    "Active (as % of on time)":"運作時間（百分比）",
    "Last Detected":"最後檢測時間",
    "Issues Diagnostics for":"為...診斷問題",
    "Other Readings":"其他讀數",
    "Anomaly Machine Learning Models":"異常檢測機器學習模型",
    "Anomaly machine learning models establish normal operation profile using historical data.":"異常檢測機器學習模型使用了歷史數據，以構築正常操作配置概況。",
    "Machine Learning model is data driven and can handle non-linear boundaries and high dimensionality.":"異常檢測機器學習模型是由數據主導，並能夠處理非線性邊界及更高維度。",
    "Show Mine Only":"僅顯示自己",
    "Bulk Upload Excel":"批量上傳至Excel",
    "Add Record":"添加紀錄",
    "Notifications":"通知",
    "Show Unack Notifications Only":"僅顯示未確認通知",
    "Add Plots":"添加圖表",
    "Filter":"過濾",
    "Drag to Add Lines to Plot":"拖曳至此以添加線至圖表",
    "Password":"密碼",
    "Login":"登入",
    "Set Server URL":"設置伺服器鏈結",
    "Variable X":"變量X",
    "Variable Y":"變量Y",
    "Facet Groups":"結合圖群組",
    "Variable Facet":"變量結合圖",
    "Chiller Optimisation Example":"冷水機優化示例",
    "Using PSO optimisation algorithm, expected COP under different operating parameters at particular cooling loads can be found as depicted by the red dots.  The historical consumption is shown as blue dots below.  By choosing optimal temperature setpoints and sequencing, energy saving can be achieved by picking the set of parameters achieving highest COP.":"運用微粒群演算法後，紅色點顯示了特定冷卻負載下不同參數的預期效能系數，藍色點顯示了能源消耗歷史。只要設定了最佳的溫度設定值和排序，再選出擁有最高效能系數的數據組合，就能夠有效節能。",
    "95% Confidence Interval":"95%信賴區間",
    "Actual observed value":"實際觀測值",
    "Fitted value":"配適值",
    "Expected value":"期待值",
    "Upload File":"上傳文件",
    "Remove existing rules":"移除現有規則",
    "Upload":"上傳",
    "Upload Excel":"上傳至Excel",
    "Maintenance Records Creation":"創建維護記錄",
    "Reference URL":"參考鏈接",
    "Fixed?":"已修復？",
    "Normal maintenance record":"正常維護紀錄",
    "Comment":"評論",
    "Add":"添加",
    "View Reference Link":"查看參考鏈接",
    "View Reference Link in New Tab":"在新分頁查看參考鏈接",
    "Optimization Saving":"優化所節省",
    "Digital Twins":"數碼對映",
    "Chiller Efficiency Surface":"冷水機效率面",
    "Optimization Saving Calculation":"優化節省計算",
    "Optimization is based on temperature reset of the chilled water supply temperature as well as optimal staging of chillers and pumps.":"優化是建基於冷凍水供應溫度的重置，以及冷水機和泵的最佳分級。",
    "Chillers' efficiency would also differ under different loading percentage, environmental conditions and external factors. This provides opportunity to improve the staging of chillers. Further optimization is possible due to unfulfilled temperature reset and differential pressure reset potential. Less cooling capacity buffer would be required if air-side sensors indicates that room temperature is optimal.":"在不同的負荷百分比，環境條件和其他外部因素的影響下，冷水機的效率也會有所變化。因此，冷水機的運作能夠通過重置溫度及壓差達到進一步的優化。如果空氣側傳感器顯示室溫為最佳，所需的冷卻容量緩衝亦會因而減少。",
    "Total Cooling Load":"Total 總冷卻負荷",
    "Duration":"持續時間",
    "Projected Energy Consumption":"預計能量消耗",
    "Saving":"節約",
    "Cost Savings":"成本節約",
    "Diagnostic Plots":"診斷圖表",
    "Power consumption forecast based on setpoint such as evaporator supply temperature and external environment factors such as condenser water temperature and outdoor air temperature.":"功耗預測是建基於不同設定值，例如蒸發器的供應溫度、以及冷凝器水溫和室外空氣溫度等外部環境因素。",
    "The charts reveal the relationship between the prediction and actual consumption.  A chart showing a strong correlation indicates a good model.":"這些圖表展現了預測量與實際消耗量之間的關係。越高相關性代表模組越好",
    "Chiller efficiency is greatly influenced by the loading of the chiller and external factor such as condenser water temperature.":"冷水機效率會因機組負荷、以及冷凝水溫度等外部因素而大幅影響。",
    "The 3D scatter plots of the power consumption reveals a efficiency surface where chiller optimization can be performed.":"功耗的立體散點圖展現了一個可以執行冷卻裝置優化的效率面。",
    "Chilled Water Supply Temp (actual)":"冷卻水供應溫度（實際）",
    "Plant COP":"設備效能系數",
    "Plant Power":"設備能量",
    "Chilled Water Supply Temp (optimized)":"冷卻水供應溫度（最優化）",
    "Original COP":"原始效能系數",
    "Optimized COP":"優化效能系數",
    "Original Power":"原始能量",
    "Optimized Power":"優化能量",
    "Menu Configuration":"菜單項目",
    "Air Side Equipment":"空氣側設備",
    "Overall Power Status":"整體能量狀態",
    "Condensing Water Pump":"冷凝水泵",
    "Power Analyzer":"能量分析儀",
    "Chilled Water Pump":"冷卻水泵",
    "Cooling Tower":"冷卻塔",
    "CHW Header":"冷卻水結合",
    "Heatmaps":"熱圖",
    "PAU Breakdown":"鮮風櫃細目",
    "PAU CD_Tem & VFD_Feedback":"鮮風櫃供應溫度及變速驅動回饋",
    "AHU CD_Tem & RT_Tem & VFD_Feedback":"風櫃供應溫度及返回溫度及",
    "AHU CD_Tem & RT_Tem & Valve_Control":"風櫃供應溫度及返回溫度及閥門控制",
    "PAU CD_Tem & Valve_Control":"鮮風櫃供應溫度及閥門控制",
    "AHU RT_Tem vs. VFD_Feedback":"風櫃返回溫度 vs. 變速驅動回饋",
    "PAU CD_Tem vs. Valve Control":"鮮風櫃供應溫度 vs. 閥門控制",
    "AHU CD_Tem vs. Valve Control":"風櫃供應溫度 vs. 閥門控制",
    "AHU Breakdown":"風櫃細目",
    "AHU CO2":"風櫃二氧化碳",
    "PAU CO2":"鮮風櫃二氧化碳",
    "Environmental Performance":"環保性能",
    "Running Status - CHWP & WCC":"運行狀態 - 冷卻水泵 & 水冷式製冷機",
    "Equipment Power Consumption":"設備能量消耗",
    "Running Status - CHWP-A & ACC":"運行狀態 - 冷卻水泵-A & 氣冷式冷卻機",
    "Running Status - WCC & CWP & CT":"運行狀態 - 水冷式製冷機 & 冷卻水泵 & 冷卻塔",
    "Running Status - AHU & PAU":"運行狀態 - 風櫃 & 鮮風櫃",
    "Running Status vs. Schedule":"運行狀態 vs. 時間表",
    "CDW Delta T vs Mean CDWP Power":"冷卻水溫度變化 vs 冷卻水泵能量的平均值",
    "WCC Cond Entering & Leaving Temperature":"水冷式製冷機的回水 & 出水溫度",
    "WCC CHWR_Temp & CHWS_Temp":"水冷式製冷機的返回 & 供應溫度",
    "WCC Cooling Load Overview":"水冷式製冷機的冷卻塔概覽",
    "WCC COP":"水冷式製冷機效能系數",
    "COP vs Cooling Loads ":"效能系數 vs 冷卻塔",
    "POA Power Factor":"能量分析儀能量因素",
    "POA Hz":"能量分析儀頻率",
    "POA Voltage":"能量分析儀電壓",
    "POA Power":"能量分析儀能量",
    "CHWP VSD_Speed_Feedback":"冷卻水泵變速驅動回饋",
    "CT Speed_Feedback":"冷卻塔速度回饋",
    "CT Wetbulb Approach":"冷卻塔濕球方法",
    "CT Breakdown":"冷卻塔明細",
    "CT Speed Feedback & Running Status":"冷卻塔速度回饋 & 運行狀態",
    "CT Entering & Leaving Temperature":"冷卻塔回水 & 出水溫度",
    "AHU PAU Temperatures and Setpoints":"風櫃及鮮風櫃的溫度及設定值",
    "CHW DP vs OAT":"冷卻水壓差 vs 室外空氣溫度",
    "Second Floor Mean Air Temperature":"二樓空氣溫度的平均值",
    "First Floor Air Temperature":"一樓空氣溫度",
    "Reset":"重置",
    "Upload Point List":"上傳傳感器列表",
    "Upload Point List CSV":"上傳傳感器列表CSV文件",
    "Point List upload":"上傳傳感器列表",
    "Upload data for":"為...上傳數據",
    "Upload CSV data for":"為...上傳數據CSV文件",
    "Add Equipment":"添加設備",
    "Add Point":"添加傳感器",
    "Edit Equipment":"編輯設備",
    "Delete Equipment":"刪除設備",
    "Upload Data":"上傳數據",
    "Edit Point":"編輯傳感器",
    "Delete Point":"刪除傳感器",
    "Algorithmic Fault Detection":"演算法故障檢測",
    "Automated Debug":"排除錯誤自動化",
    "Custom View Configuration Issues":"自訂視圖配置設定錯誤",
    "Chart Builder":"圖表生成器",
    "Are you sure you want to delete this item?":"你確定要刪除這個項目嗎？",
    "Notes":"備注",
    "Sensor Name":"感應器名稱",
    "Sensor Name Abbr":"感應器名稱縮寫",
    "Faulty":"故障",
    "Upstream ID":"上游點位ID",
    "Weight":"權重",
    "Are you sure you want to delete this sensor?":"你確定要刪除這個感應器嗎？",
    "Are you sure you want to delete this equipment?":"你確定要刪除這個設備嗎？",
    "Add Query":"添加查詢",
    "Config ID":"配置ID",
    "Config Name":"配置名稱",
    "Facility Name":"建築物名稱",
    "Equipment Tags":"設備標籤",
    "Equipment ID":"設備ID",
    "Facility ID":"建築物ID",
    "Description":"描述",
    "Sampling Frequency":"採樣頻率",
    "Meta":"關聯資料",
    "ON":"開啟",
    "OFF":"關閉",
    "Unit":"單位",
    "yes":"是",
    "Yes":"是",
    "no":"否",
    "No":"否",
    "Query":"查詢",
    "data":"數據",
    "On Only":"僅計算機器運行的時候",
    "Date range offset":"日期範圍移動",
    "Add Time Aggregation":"添加合計時間",
    "Add Aggregation":"添加合計",
    "Add Series Calculation":"添加一组數據計算",
    "Add Dataframe Transformation":"添加數據幀轉換",
    "Add Filter":"添加過濾",
    "Add Series Selection":"添加一组數據選擇",
    "Add Series Insertion":"添加一组數據",
    "Range offset":"範圍偏移",
    "Offset unit":"移動單位",
    "Offset amount":"移動數量",
    "Time Aggregation":"合計時間",
    "Frequency":"頻率",
    "Operation":"運算",
    "Divide by sampling freq":"除以採樣頻率",
    "Horizontal Aggregation":"橫向合計",
    "Name":"名稱",
    "Insert Series":"載入一组數據",
    "Field":"列",
    "Value":"價值",
    "Series Calculation":"一组數據計算",
    "Remove Others":"刪除其他",
    "Formula":"公式",
    "Dataframe Transformation":"數據幀轉換",
    "Series Selection":"一组數據選擇",
    "Add Series":"添加一组數據",
    "Please select a Sensor Name or an Equipment Name":"請選擇感應器名稱或設備名稱",
    "layout":"排版",
    "Chart Type":"圖表類型",
    "Trace Type":"顯示類型",
    "Fill":"填滿類型",
    "Fill color":"填滿顏色",
    "Y Axis":"Y軸",
    "Stack Group":"疊加圖组",
    "Render as Smooth Line":"算繪為平滑線",
    "Min":"最小",
    "Max":"最大",
    "Color":"顏色",
    "Custom Unit":"自訂單位",
    "Opacity":"不透明度",
    "Indicator Mode":"顯示模式",
    "Gauge Min":"最小測量值",
    "Gauge Max":"最大測量值",
    "Bar color":"棒顏色",
    "Border color":"邊界顏色",
    "Background color":"背景顏色",
    "Bar Mode":"棒形圖模式",
    "Show Scale":"顯示比例",
    "Custom Color Gradient":"自訂顏色漸變",
    "Donut":"環圈圖",
    "Box Points":"箱形圖點",
    "Horizontal":"水平方向",
    "Xbins Size":"X軸尺度大小",
    "Ybins Size":"Y軸尺度大小",
    "Add step":"添加步驟",
    "Gauge Steps":"測量步驟",
    "Title":"標題",
    "Chart layout":"圖表排版",
    "Height":"高度",
    "Top Margin":"上邊距",
    "Left Margin":"左邊距",
    "Right Margin":"右邊距",
    "Bottom Margin":"下邊距",
    "Hover Tooltip Behaviour":"鼠標懸停工具提示效果",
    "Show Legend":"顯示圖例",
    "Chart Colors":"圖表顏色",
    "Add Color":"添加顏色",
    "Axis settings":"軸設定",
    "X Axis Field":"X軸列",
    "Independent X Series per Query":"為每查詢設定獨立的一组X軸數據",
    "X Axis Label":"X軸標籤",
    "X Axis Format":"X軸格式",
    "Y Axis Label":"Y軸標籤",
    "Secondary Y Axis":"第二Y軸",
    "Secondary Y Axis Label":"第二Y軸標籤",
    "Color Axis Field":"顏色軸列",
    "Color Axis Scale":"顏色軸比例",
    "Color Axis Label":"顏色軸標籤",
    "3D Mode Y Axis Field":"3D模式Y軸列",
    "Close":"關閉",
    "Compare X":"比較X",
    "Closest to pointer":"最接近鼠標",
    "Primary":"主要",
    "Secondary":"第二",
    "hour":"小時",
    "day":"天",
    "week":"週",
    "month":"月",
    "year":"年",
    "Sensor ID":"感應器ID",
    "Type":"類型",
    "Connectors":"連接器",
    "Custom View Builder":"自訂視圖生成器",
    "Edit Custom View":"編輯自訂視圖",
    "Default Date Range":"預設日期範圍",
    "Link Title":"鏈接標題",
    "Column width":"列寬",
    "Edit":"編輯",
    "Duplicate":"複製",
    "Delete":"刪除",
    "Map":"地圖",
    "Pitch":"傾斜率",
    "Zoom":"放大率",
    "Center Latitude":"中心緯度",
    "Center Longitude":"中心經度",
    "Markers":"標記",
    "Image URL":"圖像網址",
    "Link URL":"鏈接網址",
    "Latitude":"緯度",
    "Longitude":"經度",
    "Add Marker":"添加標記",
    "OK":"確認",
    "Width":"寬度",
    "Radius":"半徑",
    "Blur":"模糊度",
    "Max opacity":"最大不透明度",
    "Player":"播放器",
    "Agg Frequency":"合計的頻率",
    "Agg Operation":"合計的運算",
    "Cutoff Date":"截止日期",
    "Interpolation":"插值",
    "Min X":"X最小值",
    "Max X":"X最大值",
    "Min Power":"功率最小值",
    "Max Power":"功率最大值",
    "Power Sensor":"功率感應器",
    "X Sensor":"X感應器",
    "X Title":"X標題",
    "X Agg Operation":"X合計的運算",
    "Switch Sensor":"開關感應器",
    "Use Switch":"使用開關",
    "Custom Interpolation Function":"自訂插值函數",
    "Min Cooling Load":"最小冷負荷",
    "Max Cooling Load":"最大冷負荷",
    "COP Improvement":"改進性能係數(COP)",
    "Cooling Load Sensor":"冷負荷感應器",
    "Use Filter":"使用過濾",
    "Filter Sensor":"過濾感應器",
    "Min Filter":"過濾最小值",
    "Max Filter":"過濾最大值",
    "Correlation":"相關性",
    "Relevant Variables":"相關變量",
    "Rule Active when Equipment On":"設備開啟時激活規則",
    "Rule Active when Equipment Off":"設備關閉時激活規則",
    "Rule Active Anytime":"規則隨時有效",
    "Show Cost":"顯示成本",
    "X Axis Title":"X軸標題",
    "Y Axis Title":"Y軸標題",
    "Expected Value Line Name":"預期值線名稱",
    "Fitted Value Line Name":"配適值線名稱",
    "Actual Observed Value Line Name":"實際觀察值線名稱",
    "Confidence Interval Name":"置信區間名稱",
    "Cooling Load Forecast":"冷負荷預測",
    "Staging Profile":"排序資料",
    "Heatmap":"熱圖",
    "Fault Evaluation":"故障評估",
    "Chiller Sequencing FLA":"冷水機排序(滿載電流)",
    "Chiller Sequencing Delta":"冷水機排序 Delta",
    "Cooling Load vs OAT":"冷負荷 vs 室外空氣溫度",
    "Return to Custom Views":"返回自訂視圖",
    "Add chart":"添加圖表",
    "Add Chart":"添加圖表",
    "Save as custom view":"另存為自訂視圖",
    "Add Custom Chart":"添加自訂圖表",
    "Pie":"餅形圖",
    "Bar":"棒形圖",
    "Histogram":"直方圖",
    "Stacked Area":"堆棧圖",
    "Line":"線形圖",
    "Scatter":"散點圖",
    "3D Scatter":"3D散點圖",
    "Scatter with Color Scale":"帶有色標的散點圖",
    "Optimization":"優化",
    "View All":"查看全部",
    "Changes Saved":"更改已保存",
    "Are you sure you want to delete this connector?":"您確定要刪除此連接器嗎？",
    "New Simple View":"新增基本視圖",
    "New Advanced View":"新增高級視圖",
    "Import JSON":"導入 JSON",
    "Import Preset":"導入預設",
    "Import Local Plots":"導入本機繪圖",
    "Import custom view from JSON":"從 JSON 導入自訂視圖",
    "Import":"導入",
    "Publish":"發佈",
    "Un-Publish":"取消發佈",
    "Export":"輸出",
    "Facility":"建築物",
    "Published":"發佈",
    "Top-level Link":"至頂鏈結",
    "Link position":"鏈結位置",
    "Menu Folder":"導航菜單文件夾",
    "Are you sure you want to delete this view?":"您確定要刪除此視圖嗎？",
    "View Deleted":"視圖已刪除",
    "Custom view saved":"自訂視圖已保存",
    "Are you sure you want to upload all local plots to your user account?":"您確定要將所有本機繪圖上傳到您的用戶帳戶嗎？",
    "Views Imported":"視圖已導入",
    "A custom view with this ID already exists. Are you sure you want to override it ?":"已存在具有此ID的自訂視圖。您確定要覆蓋它嗎？",
    "End date":"結束日期",
    "Dynamic Control":"動態控制",
    "Software Switches":"軟件開關",
    "Control Readings":"控制讀數",
    "Sensor Readings":"感應器讀數",
    "Point Name":"傳感器名稱",
    "Status":"狀態",
    "Error":"錯誤",
    "Equipment plots":"設備圖表",
    "Equipment name":"設備名稱",
    "Start date": "開始日期",
    "Floor name":"樓層名稱",
    "Equipment Summary":"設備概要",
    "Display equipment plots":"展示設備圖",
    "Display anomalies":"顯示異常",
    "Data Export":"輸出數據",
    "View Data":"查看數據",
    "Download CSV":"下載 CSV",
    "Time Agg Frequency":"時間合計的頻率",
    "Time Agg Operation":"時間合計的運算",
    "Return data as":"返回數據為",
    "Series name":"一组數據名稱",
    "Change Password":"更改密碼",
    "User ID":"用戶ID",
    "Update On":"更新時間",
    "Created On":"創建於",
    "Role":"角色",
    "Users":"用戶",
    "Dashboard Setup":"儀表板設置",
    "Not logged in as administrator":"未以管理員身份登錄",
    "Log Out":"登出",
    "Dashboard setup complete":"儀錶盤設置完成",
    "Back to Home":"返回首頁",
    "Current Logged In User":"當前登錄用戶",
    "Facility and Points":"建築物和傳感器",
    "Current Facility":"當前的建築物",
    "Equipment List and Points":"裝備列表及傳感器列表",
    "used":"已使用",
    "licensed":"已發放許可",
    "Setting":"設定",
    "sample":"樣本",
    "samples":"樣本",
    "every hour":"每小時",
    "Currency and Energy Pricing":"貨幣和能源定價",
    "per kWh":"每千瓦時",
    "Points List":"傳感器列表",
    "Energy Price":"能源價格",
    "Equipment On":"設備開啟",
    "Equipment Off":"設備關閉",
    "Anytime":"任何時間",
    "Active":"運作",
    "Inactive":"非運作",
    "Muted":"沉默",
    "Applicable Group(s)":"適用組別",
    "Rule Active when":"規則激活在...時候",
    "Active Status":"運作狀態",
    "Reports":"報告",
    "Test Message":"測試訊息",
    "Severity Level(s)":"嚴重程度",
    "Distribution List":"分佈列表",
    "Power Prediction":"功率預測",
    "Parameter Name":"參數名稱",
    "Parameter Value":"參數值",
    "Parameter Value Str":"參數值字符串",
    "Parameter Description":"參數說明",
    "Graphical View":"圖形視圖",
    "Model":"模型",
    "Add Model":"添加模型",
    "Model Name":"模型名稱",
    "Model Type":"模型類型",
    "Job":"工作",
    "Add Job":"添加工作",
    "New Job":"新工作",
    "No Result Yet":"沒有結果",
    "Reset all result":"重置所有結果",
    "Reset all result will delete all result and rerun with latest setting.":"重置所有結果,所有刪除的結果會使用最新設置重新運行",
    "Train Comp Power Model":"訓練冷機組功率模型",
    "This will retrain the Comp Power Model":"將重新訓練冷機組功率模型",
    "Ack Old Notifications":"已確認的舊通知",
    "Ack Old Notifications older than the following threshold or 30 days if no threshold is mentioned.":"如果未提及閾值，則確認早於以下閾值或 30 天前的舊通知",
    "End date threshold":"結束日期閾值",
    "Job ID":"工作ID",
    "Carnot Innovations Terms of Service":"Carnot Innovations 服務條款",
    "Critical":"危急",
    "Download with Maintenance":"下載(包括維護部份)",
    "Severity filter":"嚴重性過濾",
    "Notification ID":"通知 ID",
    "Occurred Times":"發生次數",
    "Focus Range":"對焦範圍",
    "Location":"地點",
    "Start Time":"開始時間",
    "End Time":"結束時間",
    "Comments":"註釋",
    "Actions Taken":"所採取的行動",
    "Reported by":"舉報人",
    "Report date":"報告日期",
    "Certified by":"通過...認證",
    "Certified date":"認證日期",
    "Endorsed by":"受...認可",
    "Endorsed date":"批准日期",
    "Menu List":"菜單列表",
    "New Folder Name":"新文件夾名稱",
    "Available Views":"可用視圖",
    "Edit Folder Name":"編輯文件夾名稱",
    "Edit Custom View Display":"編輯自訂視圖顯示",
    "Custom View Name":"自訂視圖名稱",
    "Icon":"圖標",
    "Folder cannot be nested!":"不能嵌套文件夾!",
    "Folder name must be unique.":"文件夾名稱不能重複",
    "Add Anomaly Description":"添加異常描述",
    "Relevant variable":"相關變數",
    "Equipment Regex":"設備正則表達式",
    "Time Delay":"時間延遲",
    "Open diagnostics view":"打開診斷視圖",
    "timestamp":"時間戳",
    "Top 10 overall anomaly scores":"總體異常得分前10名",
    "File must be selected.":"必須選擇文件。",
    "Exactly 1 file must be provided.":"必須只提供1個文件。",
    "Done":"完成",
    "Please select 1 file to upload.":"請選擇1個文件上傳。",
    "Please wait ... It will take up to a minute.":"請稍等... 大約等待一分鐘",
    "Upload Completed.":"上傳完成。",
    "Fail.  Please Retry.":"失敗。請重試。",
    "Add Tag":"添加標籤",
    "Connector":"連接器",
    "Add Points":"添加傳感器",
    "Point Selector":"選擇傳感器",
    "Available points":"可用的傳感器",
    "Show filters":"顯示過濾器",
    "Hide filters":"隱藏過濾器",
    "Selected points":"已選的傳感器",
    "Clear selection":"清空選項",
    "Add selected points":"添加已選傳感器",
    "Total energy consumption (kWh)":"總能耗（千瓦時）",
    "Energy Savings":"節能",
    "Add Dates":"添加日期",
    "Add Equipment Servicing Schedule":"添加設備維修計劃",
    "Applies to":"適用於",
    "Entire Site":"整個場地",
    "Floor Name":"樓層名稱",
    "View":"視圖",
    "Apply changes":"應用更改",
    "Save whiteboard":"儲存白板",
    "Edit all notes":"編輯所有筆記",
    "Add Stickie to board":"將便條紙添加到白板上",
    "Add Photo / Graphics to board":"將照片/圖形添加到白板上",
    "Add Board":"添加白板",
    "Board Name":"白板名稱",
    "Double Click to select an image.":"雙擊以選擇圖像",
    "Edit this Stickie":"編輯此便條紙",
    "Delete this Stickie":"刪除此便條紙",
    "Edit Image":"編輯圖像",
    "Edit Label":"編輯標籤",
    "Label":"標籤",
    "Label Only":"僅編輯標籤",
    "Font size":"字體大小",
    "Font color":"字體顏色",
    "Variable":"變量",
    "Microsoft authentication anomaly. Please renew login.":"Microsoft 身份驗證異常。請更新登錄。",
    "Change Backend URL":"更改後端 URL",
    "Target URL":"目標網址",
    "Setting URL.  Please wait.":"設置網址。請稍等。",
    "Set":"設定",
    "Model ID":"模型ID",
    "Target Equipment":"目標設備",
    "Model Selection":"選擇模型",
    "Model Message":"模型信息",
    "Training Data Date Range":"訓練數據日期範圍",
    "Severity Levels":"嚴重程度",
    "Phone number":"電話號碼",
    "Message":"信息",
    "Send":"發送",
    "Active - rule will be applied":"啟用 - 規則會運行",
    "Inactive - rule will not run":"非啟用 - 規則不會運行",
    "Muted - rules will be applied, but notifications (if any) will immediately be acknowledged":"沉默 - 應用規則，並且立即確認通知（如果有）",
    "Used parameters":"已使用的參數",
    "Recommended Action":"建議操作",
    "Run test":"運行測試",
    "Test the rule":"測試規則",
    "Validation succeeded!":"驗證成功！",
    "Password not matched / Password cannot be empty":"密碼不匹配/密碼不能為空",
    "Confirm New Password":"確認新密碼",
    "New Password":"新密碼",
    "Administrator":"管理員",
    "Maintainer":"維護者",
    "Operator":"操作員",
    "Updated On":"更新於",
    "Authorized Facilities":"授權建築物",
    "User Account":"用戶帳號",
    "Monthly Summary Energy/Faults":"每月總能源/故障",
    "Monthly Summary: Chiller Plant":"每月總結：冷水機組",
    "Chiller Staging":"冷水機排序",
    "Edit Maintenance Record":"編輯維護紀錄",
    "Builder":"生成器",
    "Equipment Group":"設備類型",
    "FDD Breakdown": "故障檢測診斷分析",
    "Cluster View": "群組視圖",
    "Get link": "獲取鏈接",
    "Chiller Plant Overview": "冷水機組概覽",
    "General - CHW_Header Leaving and Entering Temp": "常規-冷卻水結合離開和進入溫度",
    "General - CHW_Header DP vs OAT": "常規-冷卻水結合壓差 vs 室外空氣溫度",
    "Advanced - Cooling Load and Power Over Time": "進階-冷負荷和能量的變化",
    "Advanced - CHW_Header Depth Analysis": "冷卻水結合深度分析",
    "Cooling Load Prediction": "冷卻負荷預測",
    "Last 10 Days Cooling Load Prediction": "為期10日的冷卻負荷預測",
    "Hide Date": "隱藏日期",
    "Monthly": "每月",
    "Month Range": "月份範圍",
    "On Only Switch": "僅計算開關運行的時候",
    "Equip Select": "設備選擇",
    "Equipment Type filter": "設備類型過濾",
    "Equipment Floor filter": "設備樓層過濾",
    "Min Width": "最小寬度",
    "Borders": "邊界",
    "Restricted Access": "限制訪問權限",
    "Namespace": "名字空間",
    "Hide Controls": "隱藏控制",
    "Menu Config": "菜單項目",
    "Save As": "另存為",
    "Add Component": "添加組件",
    "Rich Text": "本文",
    "Notification Facet": "結合通知",
    "3D Viewer": "3D查看器",
    "3D Heatmap": "3D熱圖",
    "Custom Optimization": "自訂優化",
    "Custom COP Savings": "自訂節省效能係數",
    "Custom": "自訂",
    "HTML Code": "HTML代碼",
    "Custom EC": "自訂EC",
    "Animation": "動畫",
    "Enable Merge": "能夠合併",
    "Animation timer (seconds)": "動畫計時器（秒）",
    "Maintenance Summary": "維護摘要",
    "Issue Summary": "問題摘要",
    "Grahic": "圖形",
    "FDD Report": "故障檢測診斷報告",
    "Cost Breakdown": "成本分析",
    "Sensor Cailbration": "感應器校驗",
    "Energy Breakdown": "能量分析",
    "Solar": "來自太陽的",
    "Main light intensity": "主光強度",
    "Ambient light intensity": "環境光強度",
    "Show Clock": "顯示時鐘",
    "Parameters": "參數",
    "Autotuner": "自動調諧器",
    "Actual Observed Value": "載入於",
    "Fitted Value": "擬合值",
    "Expected Value": "期望值",
    "Insert at": "載入於",
    "Air-side": "空氣側",
    "Air-side Overview": "空氣側概覽",
    "Air-side CO2 Overtime": "空氣側二氧化碳的變化",
    "AHU Temp and VFD Over Time": "風櫃溫度和變速的變化",
    "Download plot as a png": "下載圖表為PNG",
    "Zoom in": "放大",
    "Zoom out": "縮小",
    "Autoscale": "自動縮放",
    "Reset axes": "重置軸",
    "Pan": "平移",
    "Toggle Spike Lines": "切換走勢圖",
    "Show closest data on hover": "遊標停留時顯示最近的數據",
    "Compare data on hover": "遊標停留時比較數據",
    "Produced with Plotly": "與Plotly製造",
    "Rows per page": "每頁行數",
    "Maintenance ID": "維護 ID",
    "View points when equipment is On": "查看設備開啟時的傳感器",
    "Reassign user for all maintenance records": "為所有維護記錄重新分配用戶",
    "Mass Reassign": "批量重新分配",
    "Currently assigned to": "當前分配給",
    "Reassign to": "重新分配給",
    "Reassign": "重新分配",
    "View Diff": "查看差異",
    "Diff mode": "差異模型",
    "Select file": "選擇文件",
    "Choose File": "選擇文件",
    "Convert categorical to numeric": "將分類轉換為數字",
    "Resampling": "重新採樣",
    "Matching": "匹配",
    "Data Upload": "數據上傳",
    "Toggle Connectors": "切換連接器",
    "Graphic": "圖形",
    "Equipment Relationships": "設備關係",
    "Equipment1": "設備1",
    "Equipment2": "設備2",
    "Graph view": "圖形視圖",
    "List view": "列表視圖",
    "Relationships type": "關係類型",
    "Equipment Relationships Upload": "設備關係上傳",
    "Point Mapping": "繪製傳感器",
    "Point Mapper": "繪製傳感器",
    "Mass Update": "批量更新",
    "Split Paths": "分隔路徑",
    "Map Points": "繪製傳感器",
    "Get Suggestions": "獲取建議",
    "Suggestions": "建議",
    "Units": "單位",
    "Delete Table": "刪除表格",
    "id": "ID",
    "path": "路徑",
    "carnot_name": "Carnot名稱",
    "point": "傳感器",
    "equip": "設備",
    "equip_type": "設備類型",
    "floor": "層數",
    "tower": "",
    "unit": "單位",
    "actions": "操作",
    "No data available": "沒有顯示數據",
    "Discovered Points": "發現傳感器",
    "upstream_id": "上游點位ID",
    "upstream_sensor_name": "上游點位感應器名稱",
    "site": "場地",
    "sensor_name": "感應器名稱",
    "sensor_desc": "感應器描述",
    "meta": "關聯資料",
    "equip_meta": "設備關聯資料",
    "Unmapped Only": "僅未繪製",
    "Scripts": "腳本",
    "Script": "腳本",
    "Version": "版本",
    "Updated": "更新",
    "Optimization Controls": "優化控制",
    "Current Value": "當前值",
    "Write": "編寫",
    "Priority": "優先順序",
    "Graphics": "圖形",
    "Dashboard": "儀表板",
    "Build time": "生成時間",
    "Coordinated Universal Time": "世界標準時間",
    "Rule Creation": "創建規則",
    "Auto-diagnose": "自動診斷資料",
    "This will disable all rules which lack the required variables. Are you sure you want to run auto-diagnostic?": "這將禁用所有缺少所需變量的規則。您確定要運行自動診斷嗎？",
    "KPI Thresholds": "關鍵績效指標門檻",
    "Custom view": "自訂視圖",
    "New Link Name": "新鏈接名稱",
    "Show Recent Notifications Only": "只顯示最近的通知",
    "Apply": "應用",
    "3D Model link": "3D模型鏈接",
    "Close testing interface": "關閉測試界面",
    "Component Titles": "組件標題",
    "Last Updated": "最後更新時間",
    "Add components": "添加組件",
    "Toggle sensor picker": "切換傳感選擇器",
    "Toggle debug mode": "切換自動排除錯誤模式",
    "Time aggregation": "合計時間",
    "Latest Only": "只顯示最近的通知",
    "Custom date range": "自訂日期範圍",
    "Presents": "展示",
    "Summary": "概要",
    "Bar - group": "分組條形圖",
    "Bar - stack": "堆疊柱形圖",
    "Bar summary": "柱形圖概要",
    "Gauge": "儀表圖",
    "Number": "數字圖",
    "Layout": "排版",
    "Legend Position": "圖例位置",
    "Colors": "顏色",
    "Limit X Axis Ticks": "限制X軸",
    "Y Axis Format": "Y軸格式",
    "Y Axis Custom Range": "自訂Y軸範圍",
    "Marker Size Field": "標記字段大小",
    "Color Axis Custom Range": "自訂色軸範圍",
    "Annotations": "註釋",
    "Text": "文字",
    "Returned series": "返回數據",
    "Add Series Insertion by Ref": "查看參考添加一組數據",
    "Add Calendar Insertion": "添加一組日曆",
    "Add Conversion to enum": "添加轉換枚舉類型",
    "Number Size": "數字大小",
    "Number Format": "數字格式",
}